
import { Component, Vue } from 'vue-property-decorator';

import {GetForm18PdfType} from "./components/Form18PdfType"

import { namespace } from "vuex-class";
import "@/store/modules/forms/form18";
const form18State = namespace("Form18");

import Form18ProcessHeader from "@/components/process/Form18/components/Form18ProcessHeader.vue";
import Spinner from "@/components/utils/Spinner.vue";
import { form18DataInfoType, form18StatusInfoType } from '@/types/Information/Form18';
import { packageInfoType } from '@/types/Information';

@Component({
    components:{
        Form18ProcessHeader,
        Spinner
    }
})
export default class SubmitForm18 extends Vue {

    @form18State.State
    public currentNoticeOfRepChangeAddressId: string;

    @form18State.State
    public form18Info: form18DataInfoType;

    stepsCompleted = {} as form18StatusInfoType;  
    mountedData = false; 
    packageInfo = {} as packageInfoType;
    submitting = false;
    errorMsg=""

    mounted() {
        this.mountedData = false;    
        this.submitting = false;    
        this.errorMsg = ""
        this.stepsCompleted = {
            first: true,
            second: true,
            third: false
        }
        this.mountedData = true;         
    }  

    public submit() {

        this.submitting = true;
        this.errorMsg =""

        const url = "/form18/efiling/"+this.currentNoticeOfRepChangeAddressId+"/submit/";

        const header = {
            responseType: "json",
            headers: {
                "Content-Type": "application/json",
            }
        }

        const body = {
            document_type: GetForm18PdfType(this.form18Info) //"CNAC"
        }

        this.$http.post(url, body, header)
        .then(res => {                            
            // this.submitting = false;
            if(res.data?.message=="success" && res.data?.redirectUrl){
                const eFilingUrl = res.data?.redirectUrl
                location.replace(eFilingUrl);
            }else
                this.submitting = false;
        }, err => {
            console.log(err.response?.data?.message);
            const generalError = " Error in submission. Please refresh the page and try again."
            if(err.response?.data?.message)
                this.errorMsg = err.response.data.message
            else if(err.response?.data?.detail)
                this.errorMsg = err.response.data.detail+generalError
            else
                this.errorMsg = generalError
            this.submitting = false;
        });        
    }

    public cancel() {
        this.$router.push({name: "dashboard" }) 
    }
}
